import { StateNode, TLStateNodeConstructor } from "tldraw"
import { Idle } from "./Idle"
import { Pointing } from "./Pointing"

/** @public */
export class LDLineShapeTool extends StateNode {
  static override id = "custom-line"
  static override initial = "idle"
  static override children(): TLStateNodeConstructor[] {
    return [Idle, Pointing]
  }

  override shapeType = "custom-line"
}
